import { render, staticRenderFns } from "./RememberPassword.vue?vue&type=template&id=01a17e04&scoped=true"
import script from "./RememberPassword.vue?vue&type=script&lang=js"
export * from "./RememberPassword.vue?vue&type=script&lang=js"
import style0 from "./RememberPassword.vue?vue&type=style&index=0&id=01a17e04&prod&lang=scss&scoped=true"
import style1 from "./RememberPassword.vue?vue&type=style&index=1&id=01a17e04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a17e04",
  null
  
)

export default component.exports